import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    document.body.style.overflow = '';
  }, [location]);

  const navLinks = [
    { path: '/solutions', label: 'Solutions' },
    { path: '/industries', label: 'Industries' },
    { path: '/case-studies', label: 'Case Studies' },
    { path: '/insights', label: 'Insights' },
    { path: '/about', label: 'About' },
    { path: '/disensystem-h1b', label: 'H1B Form' },
  ];

  const toggleMobile = () => {
    const next = !mobileOpen;
    setMobileOpen(next);
    document.body.style.overflow = next ? 'hidden' : '';
  };

  return (
    <>
      <nav
        className="navbar"
        style={scrolled ? { background: 'rgba(2,6,23,0.25)', borderBottomColor: 'rgba(34,211,238,0.12)' } : {}}
      >
        <div className="nav-container">
          <Link to="/" className="logo" onClick={() => setMobileOpen(false)}>
            <img
              src="/DISENAILOGOmain.png"
              alt="Disen Systems"
              className="logo-img"
            />
          </Link>

          <ul className="nav-menu">
            {navLinks.map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className={location.pathname === link.path ? 'active' : ''}
                >
                  {link.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/contact" className="btn-book-call">Book a Call</Link>
            </li>
          </ul>

          {/* Hamburger */}
          <button
            className={`mobile-toggle ${mobileOpen ? 'open' : ''}`}
            onClick={toggleMobile}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>

      {/* Mobile Drawer */}
      <div className={`mobile-drawer ${mobileOpen ? 'open' : ''}`}>
        {navLinks.map((link) => (
          <Link
            key={link.path}
            to={link.path}
            className={`drawer-link ${location.pathname === link.path ? 'active' : ''}`}
            onClick={() => {
              setMobileOpen(false);
              document.body.style.overflow = '';
            }}
          >
            {link.label}
          </Link>
        ))}
        <div className="drawer-cta">
          <Link
            to="/contact"
            className="btn-primary"
            onClick={() => {
              setMobileOpen(false);
              document.body.style.overflow = '';
            }}
          >
            Book a Call →
          </Link>
        </div>
      </div>
    </>
  );
};

export default Navbar;
